module.exports = __webpack_public_path__ + "img/mf.d742f1f8.png";